import { createSlice } from "@reduxjs/toolkit";
import { RootStateOrAny } from "react-redux";

export const artistasSlice = createSlice({
  name: "users",
  initialState: {
    artistaSelecionado: {},
  },
  reducers: {
    selectArtist: (state, action) => {
      state.artistaSelecionado = action.payload;
    },
  },
});

export const { selectArtist } = artistasSlice.actions;

export const artistaSelecionado = (state: RootStateOrAny) =>
  state.artistaSelecionado;

export default artistasSlice.reducer;
